import { i18n } from 'config/i18n';
import config from 'config/config';
import { humanize } from 'underscore.string';

export const getNavItems = (tag, pageType, drugs = [], sideEffects = [], tagOptions = {}) => {
  const isCondition = pageType === 'conditions';
  const isTreatment = pageType === 'treatments';
  const { hasEditorial, hasArticles, hasData } = tagOptions;
  return [
    hasEditorial && {
      as: `/${pageType}/${tag}`,
      link: `/tags/editorial?tagId=${tag}&pathname=/${pageType}/${tag}`,
      isCrawlable: true,
      id: 'home',
      content:  i18n.t('Information'),
    },
    {
      as: hasEditorial ? `/${pageType}/${tag}/best-posts` : `/${pageType}/${tag}`,
      link: hasEditorial ? `/tags/tagsPostList?listId=best-posts&tagId=${tag}&pathname=/${pageType}/${tag}/best-posts` : `/tags/editorial?tagId=${tag}&pathname=/${pageType}/${tag}`,
      isCrawlable: true,
      id: hasEditorial ? 'best-posts' : 'home',
      content: i18n.t('Top Posts'),
    },
    hasArticles && {
      as: `/${pageType}/${tag}/articles`,
      link: `/articles/articleList?context=${pageType}&subContext=${tag}`,
      isCrawlable: true,
      content: i18n.t('Articles'),
      id: 'articles',
    },
    isCondition && drugs.length !== 0 && {
      as: `/${pageType}/${tag}/t/drugs`,
      link: `/tags/tagsPostList?listId=drugs&tagId=${tag}&pathname=/${pageType}/${tag}/t/drugs`,
      isCrawlable: false,
      content: i18n.t('Drugs'),
      id: 'drugs',
    },
    isCondition && sideEffects.length !== 0 && {
      as: `/${pageType}/${tag}/symptoms`,
      link: `/tags/tagsPostList?listId=symptoms&tagId=${tag}&pathname=/${pageType}/${tag}/symptoms`,
      isCrawlable: true,
      content: i18n.t('Symptoms'),
      id: 'symptoms',
    },
    isTreatment && {
      as: `/${pageType}/${tag}/t/questions`,
      link: `/tags/tagsPostList?listId=questions&tagId=${tag}&pathname=/${pageType}/${tag}/t/questions`,
      isCrawlable: false,
      content: i18n.t('Questions'),
      id: 'questions',
    },
    isTreatment && sideEffects.length !== 0 && {
      as: `/${pageType}/${tag}/side-effects`,
      link: `/tags/tagsPostList?listId=side-effects&tagId=${tag}&pathname=/${pageType}/${tag}/side-effects`,
      isCrawlable: true,
      content: i18n.t('Side Effects'),
      id: 'side-effects',
    },
    hasData && {
      as: `/${pageType}/${tag}/t/data`,
      link: `/tags/data?pathname=/${pageType}/${tag}/t/data&tagId=${tag}`,
      isCrawlable: false,
      id: 'data',
      content: i18n.t('Data'),
    },
  ].filter(x => !!x);
};

export const getBannerImage = tagId => {
  return `${config.cdn.tags}${tagId}/banner.jpg`;
};

const pageTypeToConceptMap = {
  'conditions': 'condition',
  'treatments': 'drug',
};

export const getConceptFromPageType = (pageType) => {
  return pageTypeToConceptMap[pageType];
};

export const getPageTypeFromConcept = (concept) => {
  return Object.keys(pageTypeToConceptMap).find(key => pageTypeToConceptMap[key] === concept);
};

const mapTags = tags => {
  if (!tags || tags.length === 0) return [];
  return tags.map(tag => ({
    name: tag.title,
  }));
};

export const getTitle = (tag, tagOptions) => tagOptions.customTitle || humanize(tag);

export const formatTagsData = tagsPageData => {
  const result = tagsPageData.result;
  const groups = tagsPageData.groups;
  const users = tagsPageData.users;
  let entity = {};

  entity.entity = result.entity;
  entity.drugs = result.drugs;
  entity.total = result.total;

  // b/e sometimes send a response back with an empty brand object, which we do not want to display
  let brands = result.entity.brands;
  if (brands && brands.length !== 0 && brands[0].displayName === '') {
    entity.entity.brands = [];
  }

  entity.dosages = result.dosages;
  entity.hits = result.hits.map(hit => {
    if (!hit.groupCode) {
      hit.groupCode = groups.find(group => {
        return group.groupId === hit.groupId;
      }).groupId;
    }
    hit.formattedGroupName = groups.find(group => {
      return group.groupId === hit.groupId;
    }).name;
    hit.author = users.find(user => {
      return user.userId === hit.userId;
    });
    if (hit.snippets) {
      hit.snippet = hit.snippets.join(' ').slice(0, 141).concat('...');
    }
    //return formatPost(hit, tagsPageData);
    return hit;
  });

  // Filter groups so that only the groups in both groups array and groupIds on entity are included
  const filteredGroupIds = entity.entity.groupIds.filter(entityGroup => {
    let contains = false;
    groups.forEach( group => {
      if (group.groupId === entityGroup.groupId) {
        contains = true;
      }
    });
    return contains;
  });

  entity.relatedTreatments = mapTags(entity.entity.mayTreat);
  entity.relatedConditions = mapTags(entity.entity.similarTerms);

  return entity;
};
